module.exports = __webpack_public_path__ + "static/media/bg-palm.25a495ba.svg";